import { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import ChatList from "./Chat/ChatList";
import ChatWindow from "./Chat/ChatWindow";
import "../../styles/components/management/Chat/Chat.css";

export default function Chat() {
  const { user, loading } = useAuth();
  const [selectedBooking, setSelectedBooking] = useState(null);

  useEffect(() => {
    if (!loading && !user) {
      window.location.href = "/login";
    }
  }, [loading, user]);

  if (loading) return <div className="chat-loading">Loading...</div>;

  const isMobile = window.innerWidth <= 768;

  return (
    <div className="chat-container">
      {(!isMobile || !selectedBooking) && (
        <ChatList setSelectedBooking={setSelectedBooking} user={user} />
      )}
      {selectedBooking && (
        <ChatWindow
          booking={selectedBooking}
          user={user}
          goBack={() => setSelectedBooking(null)}
        />
      )}
    </div>
  );
}
